/* eslint-disable */
import axios from "@/app/Axios";
import { ref } from "vue";

export default class Selects {
    async loadDataCalibres() {
        try {
            const response = await axios.get("/calibrearma");
            const data = response.data.post;

            //            if (Array.isArray(data) && data.every(item => item.descripcion)) {
            if (Array.isArray(data) && data.every(item => item.descripcion && item.codigo_calibre)) {
                /* console.log("es mi data:", data.every(item => item.descripcion));
                this.calibres = data
                console.log("es mi this:calibres:", this.calibres);
                return this.calibres; */
                //console.log("Descripciones:", descriptions);
                const descriptions = data.map(item => item.descripcion);
                //const codcalibre = data.map(item => item.codigo_calibre);
               /*  const calibresData = data.map(item => ({
                    descriptions: item.descripcion,
                    codigo_calibre: item.codigo_calibre,
                })); */
                return descriptions;
                //return calibresData;
            } else {
                console.error("Los datos cargados no tienen la propiedad 'descripcion'.");
                return [];
            }
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    async loadDatadocumento() {
        try {
            const response = await axios.get("/documento");
            const data = response.data.post;
            
            if (Array.isArray(data) && data.every(item => item.tipo_documento)) {
                const descriptions = data.map(item => item.tipo_documento);
              //  console.log("Descripciones del documento:", descriptions);
                return descriptions;
            } else {
                console.error("Los datos cargados no tienen la propiedad 'descripcion'.");
                return [];
            }
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    /* async loadDataTipoArma() {
        try {
            const response = await axios.get("/tipoarma");
            const data = response.data.post;

            if (Array.isArray(data) && data.every(item => item.descripcion)) {
                const descriptions = data.map(item => item.descripcion);
                return descriptions;
            } else {
                console.error("Los datos cargados no tienen la propiedad 'descripcion'.");
                return [];
            }
        } catch (error) {
            console.error(error);
            return [];
        }
    } */
    async loadDataTipoArma() {
        try {
            const response = await axios.get("/tipoarma");
            const data = response.data.post;

            if (Array.isArray(data) && data.every(item => item.codigo_tipo && item.descripcion)) {
                const tiposArma = data.map(item => ({
                    codigo_tipo: item.codigo_tipo,
                    descripcion: item.descripcion
                }));
                return tiposArma;
            } else {
                console.error("Los datos cargados no tienen las propiedades 'codigo_tipo' y 'descripcion'.");
                return [];
            }
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    async loadDataProcedencia() {
        try {
            const response = await axios.get("/procedencia");
            const data = response.data.post;

            if (Array.isArray(data) && data.every(item => item.descripcion)) {
                const descriptions = data.map(item => item.descripcion);
               // console.log("Descripciones del pais de procedencia:", descriptions);
                return descriptions;
            } else {
                console.error("Los datos cargados no tienen la propiedad 'descripcion'.");
                return [];
            }
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    async loadDataClasificacionarma() {
        try {
            const response = await axios.get("/clasificacionarma");
            const data = response.data.post;

            if (Array.isArray(data) && data.every(item => item.descripcion)) {
                const descriptions = data.map(item => item.descripcion);
               // console.log("Descripciones de la clasificacion del arma:", descriptions);
                return descriptions;
            } else {
                console.error("Los datos cargados no tienen la propiedad 'descripcion'.");
                return [];
            }
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    async loadDatadocumento2() {
        try {
            const response = await axios.get("/documento"); // Reemplaza con la URL de tu API
            if (response.status === 200) {
                return response.data.post;
            } else {
                console.error("Error al cargar datos desde la API");
                return [];
            }
        } catch (error) {
            console.error("Error al cargar opciones desde la API:", error);
            return [];
        }
    }
    async loadDataCalibres2() {
        try {
            const response = await axios.get("/calibrearma");
            if (response.status === 200) {
                return response.data.post;
            } else {
                console.error("Error al cargar datos desde la API");
                return [];
            }
        } catch (error) {
            console.error("Error al cargar opciones desde la API:", error);
            return [];
        }
    }
    async loadDataTipoArma2() {
        try {
            const response = await axios.get("/tipoarma");
            if (response.status === 200) {
                return response.data.post;
            } else {
                console.error("Error al cargar datos desde la API");
                return [];
            }
        } catch (error) {
            console.error("Error al cargar opciones desde la API:", error);
            return [];
        }
    }
    async loadDataProcedencia2() {
        try {
            const response = await axios.get("/procedencia");
            if (response.status === 200) {
                return response.data.post;
            } else {
                console.error("Error al cargar datos desde la API");
                return [];
            }
        } catch (error) {
            console.error("Error al cargar opciones desde la API:", error);
            return [];
        }
    }
    async loadDataClasificacionarma2() {
        try {
            const response = await axios.get("/clasificacionarma");
            if (response.status === 200) {
                return response.data.post;
            } else {
                console.error("Error al cargar datos desde la API");
                return [];
            }
        } catch (error) {
            console.error("Error al cargar opciones desde la API:", error);
            return [];
        }
    }
}

